import React, { useState, useEffect } from 'react'
import BreadCrumbComp from '../../../components/breadCrumb'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { callApiAsync, getSurveyByOrderId, submitSurveyAnswers, getCallCurrentUser } from '../../../services/apiService'
import { getTodayYMD, getTodayDateTime } from '../../../utils/dateUtils'
import { formatCustomDateIsoString } from '../../../services/dateService'
// Fechas: ver .muxi/development/conocimiento-migrado-cursor.md — dateUtils para hoy y envío; formatCustomDateIsoString para mostrar.
import FormRadioButton from '../../../components/formRadioButton'
import LaddaButton from '../../../components/buttons/laddaButton'
import CustomSnackbar from '../../../components/snackbar'
import { getCookie } from '../../../utils/getCookie'
import ViewSurveyResultsModal from './viewSurveyResultsModal'

const AnswerSurveyNational = () => {
    const { surveyOrderId } = useParams()
    const [loading, setLoading] = useState(false)
    const [questions, setQuestions] = useState([])
    const [orderNumber, setOrderNumber] = useState('')
    const [orderInfo, setOrderInfo] = useState(null)
    const [alreadyAnswered, setAlreadyAnswered] = useState(false)
    const [existingAnswerId, setExistingAnswerId] = useState(null)
    const [userInfo, setUserInfo] = useState(null)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')
    const [openViewResultsModal, setOpenViewResultsModal] = useState(false)

    const ratingOptions = Array.from({ length: 10 }, (_, i) => ({
        label: String(i + 1),
        value: i + 1
    }))

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            p1: null,
            p2: null,
            p3: null,
            p4: null,
            p5: null,
            p6: null,
            p7: null,
            p8: null,
            p9: null,
            p10: null
        }
    })

    useEffect(() => {
        if (surveyOrderId) {
            loadUserInfo()
            loadSurvey()
        }
    }, [surveyOrderId])

    const loadUserInfo = async () => {
        const userSesion = getCookie("sesion")
        if (userSesion && userSesion.id_usuario) {
            await callApiAsync(
                () => getCallCurrentUser(userSesion.id_usuario),
                (resp) => {
                    const data = resp?.data ?? resp
                    setUserInfo({
                        id: userSesion.id_usuario,
                        nombre: data.nombre || '',
                        cargo: data.cargo || '',
                        area: data.area || '',
                        cargoId: userSesion.cargo_id || null
                    })
                },
                null
            )
        }
    }

    const loadSurvey = async () => {
        setLoading(true)
        const userSesion = getCookie("sesion")
        const userId = userSesion?.id_usuario || null

        await callApiAsync(
            () => getSurveyByOrderId(surveyOrderId, userId),
            (resp) => {
                const data = resp?.data ?? resp
                const questionsData = Array.isArray(data.questions) ? data.questions : []
                
                setQuestions(questionsData)
                setOrderNumber(data.orderNumber || '')
                setAlreadyAnswered(data.alreadyAnswered || false)
                setOrderInfo(data.orderInfo || null)
                if (data.existingAnswer && data.existingAnswer.id) {
                    setExistingAnswerId(data.existingAnswer.id)
                }
                
                setLoading(false)
            },
            (error) => {
                setLoading(false)
            }
        )
    }

    const handleViewResults = () => {
        if (existingAnswerId) {
            setOpenViewResultsModal(true)
        }
    }

    const handleCloseViewResultsModal = () => {
        setOpenViewResultsModal(false)
    }

    const onSubmit = async (formData) => {
        if (!userInfo || !userInfo.id) {
            setSnackbarMessage('No se pudo identificar al usuario. Por favor, inicie sesión.')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            return
        }

        setLoading(true)

        const answers = [
            formData.p1, formData.p2, formData.p3, formData.p4, formData.p5,
            formData.p6, formData.p7, formData.p8, formData.p9, formData.p10
        ]

        // Validar que todas las respuestas estén completas
        if (answers.some(answer => !answer || answer < 1 || answer > 10)) {
            setSnackbarMessage('Por favor, responda todas las preguntas (1-10)')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            setLoading(false)
            return
        }

        const dataToSend = {
            userId: userInfo.id,
            answers: answers,
            response_date: getTodayYMD(),
            response_datetime: getTodayDateTime()
        }

        await callApiAsync(
            () => submitSurveyAnswers(surveyOrderId, dataToSend),
            () => {
                setSnackbarMessage('Encuesta enviada correctamente')
                setSnackbarSeverity('success')
                setSnackbarOpen(true)
                setLoading(false)
                // Recargar para mostrar el mensaje de "ya respondida"
                setTimeout(() => {
                    loadSurvey()
                }, 1500)
            },
            (error) => {
                setLoading(false)
            }
        )
    }

    if (loading && questions.length === 0) {
        return (
            <div>
                <BreadCrumbComp />
                <div className="searchTitle">
                    <h1>Cargando encuesta...</h1>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className="searchTitle">
                <h1>ENCUESTA CLIENTE INTERNO</h1>
            </div>

            <div className="table-container">
                {alreadyAnswered ? (
                    <div>
                        <div style={{ textAlign: 'center'}}>
                            <h2 className="title-bio-details-chard" style={{ marginBottom: '20px', color: '#6C5CE7' }}>
                                Esta encuesta ya fue contestada por ti
                            </h2>
                        </div>

                        {orderInfo && (
                            <div style={{ 
                                border: '1px solid #e0e0e0', 
                                borderRadius: '8px', 
                                padding: '15px', 
                                marginBottom: '20px',
                                backgroundColor: '#fff'
                            }}>
                                <h3 className="select-form-label" style={{ 
                                    color: '#6C5CE7', 
                                    fontWeight: 'bold',
                                    marginBottom: '12px',
                                    fontSize: '14px'
                                }}>
                                    Información de la Orden
                                </h3>
                                <Grid container spacing={2}>
                                    {orderInfo.origin && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Origen:</strong> {orderInfo.origin}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderNumber && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Nro de Orden:</strong> {orderNumber}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderInfo.provider && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Proveedor:</strong> {orderInfo.provider}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderInfo.transportMode && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Modalidad de Transporte:</strong> {orderInfo.transportMode}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderInfo.departureDateProvider && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Fecha salida Inst. proveedor:</strong> {formatCustomDateIsoString(String(orderInfo.departureDateProvider))}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderInfo.arrivalDateCustoms && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Fecha llegada a Aduana:</strong> {formatCustomDateIsoString(String(orderInfo.arrivalDateCustoms))}
                                            </p>
                                        </Grid>
                                    )}
                                    {orderInfo.transitTime !== null && orderInfo.transitTime !== undefined && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                <strong>Tiempo en tránsito:</strong> {orderInfo.transitTime} días
                                            </p>
                                        </Grid>
                                    )}
                                </Grid>
                            </div>
                        )}

                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <LaddaButton
                                variant="contained"
                                onClick={handleViewResults}
                                backgroundColor="#6C5CE7"
                                height="50px"
                                borderRadius="15px"
                                width="300px"
                            >
                                <div className="IHContainer align-center">
                                    <p className="button_text">Ver Mis Respuestas</p>
                                </div>
                            </LaddaButton>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-20">
                            <div style={{ 
                                border: '2px solid #6C5CE7', 
                                borderRadius: '8px', 
                                padding: '15px', 
                                marginBottom: '20px',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                                    Seleccionando un número del 1 al 10, donde: <strong>1 significa Muy insatisfecho(a)</strong> y <strong>10 significa Muy satisfecho(a)</strong>
                                </p>
                            </div>

                            {orderInfo && (
                                <div style={{ 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px', 
                                    padding: '15px', 
                                    marginBottom: '20px',
                                    backgroundColor: '#fff'
                                }}>
                                    <h3 className="select-form-label" style={{ 
                                        color: '#6C5CE7', 
                                        fontWeight: 'bold',
                                        marginBottom: '12px',
                                        fontSize: '14px'
                                    }}>
                                        Información de la Orden
                                    </h3>
                                    <Grid container spacing={2}>
                                        {orderInfo.origin && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Origen:</strong> {orderInfo.origin}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderNumber && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Nro de Orden:</strong> {orderNumber}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderInfo.provider && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Proveedor:</strong> {orderInfo.provider}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderInfo.transportMode && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Modalidad de Transporte:</strong> {orderInfo.transportMode}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderInfo.departureDateProvider && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Fecha salida Inst. proveedor:</strong> {formatCustomDateIsoString(String(orderInfo.departureDateProvider))}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderInfo.arrivalDateCustoms && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Fecha llegada a Aduana:</strong> {formatCustomDateIsoString(String(orderInfo.arrivalDateCustoms))}
                                                </p>
                                            </Grid>
                                        )}
                                        {orderInfo.transitTime !== null && orderInfo.transitTime !== undefined && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                                    <strong>Tiempo en tránsito:</strong> {orderInfo.transitTime} días
                                                </p>
                                            </Grid>
                                        )}
                                    </Grid>
                                </div>
                            )}

                            <Grid container spacing={3}>
                                {questions.map((question) => (
                                    <Grid item xs={12} key={question.questionNumber}>
                                        <div className="mb-20" style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            backgroundColor: '#fff'
                                        }}>
                                            <p className="select-form-label" style={{ 
                                                color: '#6C5CE7', 
                                                fontWeight: 'bold',
                                                marginBottom: '10px',
                                                fontSize: '16px'
                                            }}>
                                                Pregunta {question.questionNumber}
                                            </p>
                                            <p className="detail-label" style={{ 
                                                marginBottom: '15px', 
                                                fontSize: '14px',
                                                color: '#333'
                                            }}>
                                                {question.questionText}
                                            </p>
                                            <FormRadioButton
                                                name={`p${question.questionNumber}`}
                                                control={control}
                                                label=""
                                                options={ratingOptions}
                                                error={errors[`p${question.questionNumber}`]}
                                                flexible={true}
                                            />
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>

                        <div className="HContainer j-center" style={{ marginTop: '30px' }}>
                            <LaddaButton
                                type="submit"
                                variant="contained"
                                backgroundColor="#6C5CE7"
                                height="50px"
                                borderRadius="15px"
                                width="400px"
                                disabled={loading}
                            >
                                <div className="IHContainer align-center">
                                    <p className="button_text">Enviar Encuesta</p>
                                </div>
                            </LaddaButton>
                        </div>
                    </form>
                )}
            </div>

            <ViewSurveyResultsModal
                open={openViewResultsModal}
                handleClose={handleCloseViewResultsModal}
                answerId={existingAnswerId}
            />

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </div>
    )
}

export default AnswerSurveyNational
